/* src/app/component/custom-toast/custom-toast.component.scss */
.custom-toast {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 20px 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  font-size: 14px;
  color: white;
  margin: 10px;
}
.custom-toast.toast-success {
  background-color: #28a745;
}
.custom-toast.toast-error {
  background-color: #dc3545;
}
.custom-toast .toast-content {
  display: flex;
  align-items: center;
  width: 100%;
}
.custom-toast .toast-content span {
  flex-grow: 1;
  margin-right: 20px;
}
.custom-toast .toast-content .close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 14px;
  cursor: pointer;
}
/*# sourceMappingURL=custom-toast.component-RN7ADMJF.css.map */
